angular.module('wbDashboard').controller('PlansControllerAurea',
    ['$scope', '$q', 'User', 'Account', 'Message', 'PlanService', 'Track', '$uibModal',
function ($scope, $q, User, Account, Message, PlanService, Track, $uibModal) {
    //this controller lists all the plans

    $scope.pageData = {
        sending: false,
        errorMsg: null,
    };
    $scope.forms = {};
    $scope.currentYear = new Date().getFullYear();

    $scope.PS = PlanService;

    $scope.getPath = function (section, type, fslug) {
        var pslug = $scope.$stateParams.pslug;
        switch (section) {
            case 'info':
                if (type === 'feature') {
                    return 'app/themes/aurea/segments/plans/plans/' + pslug + '/features/' + fslug + '/plans.info.feature.' + fslug + '.tpl.html';
                } else if (type === 'plan') {
                    return 'app/themes/aurea/segments/plans/plans/' + pslug + '/plans.info.plan.' + fslug + '.tpl.html';
                }
                break;
            case 'detail':
                if (type === 'feature') {
                    return 'app/themes/aurea/segments/plans/plans/' + pslug + '/features/' + fslug + '/plans.detail.feature.' + fslug + '.tpl.html';
                } else if (type === 'plan') {
                    return 'app/themes/aurea/segments/plans/plans/' + pslug + '/plans.detail.plan.' + fslug + '.tpl.html';
                }
                break;
            case 'edit':
                return 'app/themes/aurea/segments/plans/plans/' + pslug + '/features/' + fslug + '/plans.detail.feature.edit.' + fslug + '.tpl.html';
        }
    };

    $scope.addPIA = function(itemName) {
        $scope.pageData.sending = true;

        var retirement = User.getMilestoneByType('retirement') || {};
        // old: if (!retirement) return $q.when();
        // if there is no retirement, addPIAModal will direct to create a new milestone instead.

        var msId = retirement.id;

        return Account.addPIAModal(msId, itemName).then(function(response) {
            User.retrieveMilestones(msId, true);
            User.retrieveActivityPending(true);
            return User.retrieveOverview(true);
        }).then(function(response) {
            Message.set({
                text:"Personal Account has been added.",
                type: "success"
            });
        }).catch(function(response) {
            if (response && response !== "escape key press") {
                //if the modal was only closed there is no response
                Message.set({
                    text: "Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
            }
            throw response;
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.moreInfoModal = function(planSlug) {
        modalInstance = $uibModal.open({
            templateUrl: "plans.more.info."+planSlug+".modal.tpl.html",
            size: 'md',
            scope: $scope,
            windowClass: 'plan-info-confirm-modal'
        });

        modalInstance.result.then(function () {
            return User.sendFeedback({
                fields: {
                    key: planSlug,
                    platform: "desktop",
                    response: "The user has requested this feature."
                }
            }).then(function() {
                Message.set({
                    text: "Aye Aye, Captain: We’ll keep you updated.",
                    type: "success"
                });
            });
        }).catch(angular.noop).finally(function() {
        });

    };

    $scope.$watch(function() { return PlanService.getPlans(); }, function(plans) {
        $scope.plans = plans;
    });

    $scope.$watch(function() { return User.getOverview(); }, function(overview) {
        if (overview) {
            $scope.overview = overview;
        }
    });

}]);
